/*
 * useRedirectOnEmptyCart - this hook is used to redirect the user on empty cart page
 * if the cart is empty
 */

import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import * as actions from '@redux-actions/';

const useRedirectOnEmptyCart = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()

    const cart = useSelector(state => state.cart.cart);
    const isLoading = useSelector(state => state.cart.isLoading);
    const isLoaded = useSelector(state => state.cart.isLoaded);
    const config = useSelector(state => state.cart.config);

    useEffect(() => {
        if((!cart || (!!cart && !cart.orderItem)) && !isLoading && !isLoaded) {
            dispatch(actions.startLoading());
            navigate(config.pagesUrl.cart);
        }
    }, [cart, isLoading, isLoaded]);
}

export default useRedirectOnEmptyCart;